import { render, staticRenderFns } from "./buyerBehavior.vue?vue&type=template&id=96ca3d22&scoped=true&"
import script from "./buyerBehavior.vue?vue&type=script&lang=js&"
export * from "./buyerBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ca3d22",
  null
  
)

export default component.exports